import React from "react";
import { Link } from "react-router-dom";
import { wineData } from '../Components/wineData';

const Products = () => {
    return (
        <section className="bg-white px-6 py-12">
            <div className="text-center max-w-3xl mx-auto mb-16">
                <h1 className="text-4xl sm:text-5xl font-extrabold text-[--primary-wine] mb-4">
                    Premium Homemade Fruit Wines 
                </h1>
                <p className="text-lg text-gray-600 leading-relaxed">
                    Discover the unique essence of handcrafted wines.
                </p>
            </div>

            {/* Grid layout for minimal cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
                {wineData.map((item) => (
                    <Link 
                        to={`/product/${item.id}`} 
                        key={item.id}
                        className="border border-gray-200 rounded-xl p-4 flex flex-col items-center hover:shadow-lg transition-shadow duration-300 cursor-pointer"
                    >
                        <img 
                            src={item.image} 
                            alt={item.name} 
                            className="w-48 h-48 object-contain mb-4" 
                        />
                        <h2 className="text-lg font-bold text-[--primary-wine-dark] text-center mb-2 line-clamp-2">
                            {item.name}
                        </h2>
                        <p className="text-xl font-semibold text-[var(--primary-wine)] mt-auto">
                            <span className="text-sm">Rs</span> {item.price}
                        </p>
                        <button className="w-full mt-4 py-2 bg-gray-100 text-[--primary-wine] font-semibold rounded hover:bg-gray-200 transition">
                            View Details
                        </button>
                    </Link>
                ))}
            </div>
        </section>
    );
};

export default Products;